import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Text } from '../Text/Text';
import { useMessageBar } from './MessageBarContext';
import { messageBarPalette } from './palette';
export var MessageBarTitle = function (_a) {
    var children = _a.children, _b = _a.component, component = _b === void 0 ? 'div' : _b;
    var variant = useMessageBar();
    return (React.createElement(SText, { component: component, "$variant": variant }, children));
};
var SText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 800;\n"], ["\n  color: ", ";\n  font-weight: 800;\n"])), function (_a) {
    var $variant = _a.$variant;
    return messageBarPalette[$variant].color;
});
var templateObject_1;
//# sourceMappingURL=MessageBarTitle.js.map